import {
  Stack,
  Select as MuiSelect,
  MenuItem,
  FormHelperText,
  Typography
} from "@mui/material";

export const Item = () => <div />

export const Select = ({ label, options, value, onChange, subtext, onTooltip, children }) => {
  let description = "";

  const items = (children instanceof Array ? children : [children]).map((el, index) => {
    if (el.props.value === value) {
      description = el.props.description;
    }

    return <MenuItem key={index} value={el.props.value}>{el.props.label}</MenuItem>;
  });

  return (
    <Stack direction="column" spacing={2}>
      {label}
      {subtext && <Typography variant="body2" color="#999" sx={{marginTop: '5px!important'}}>{subtext}</Typography>}
      <MuiSelect variant="outlined" value={value} onChange={e => onChange(e.target.value)}>
        {items}
      </MuiSelect>
      <FormHelperText>{description}</FormHelperText>
    </Stack>
  )
}